import { states } from '@/constants/states'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { AutocompleteInput } from '@/components/inputs'
import { useReadMunicipalities } from '@/api/accounting-dealer'
import { useMemo } from 'react'
import { InfoOutlined } from '@mui/icons-material'
import { FiscalNoteFormData } from '../../schema'

export function Municipality() {
  const { control, watch } = useFormContext<FiscalNoteFormData>()

  const stateCode = watch('state_uf')

  const { data: municipalities, isLoading: readingMunicipalities } =
    useReadMunicipalities(stateCode ?? '')

  const municipalityOptions = useMemo(
    () => municipalities?.map((municipality) => municipality.ibge_code) || [],
    [municipalities],
  )

  return (
    <Box>
      <Typography variant="h6" mb={2}>
        Local de prestação de serviço{' '}
        <Tooltip title="Só deve ser alterado em caso de ISS retido. Procure nossa equipe para exceções.">
          <InfoOutlined
            fontSize="small"
            sx={{ verticalAlign: 'text-bottom' }}
          />
        </Tooltip>
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} gap={2}>
        <AutocompleteInput
          control={control}
          name="state_uf"
          label="Estado"
          options={states.map((state) => state.code)}
          data-testid="state-uf"
        />
        <AutocompleteInput
          control={control}
          name="municipality_ibge_code"
          label="Cidade"
          options={municipalityOptions}
          getOptionLabel={(option) =>
            municipalities?.find((item) => item.ibge_code === option)?.name ??
            ''
          }
          loading={readingMunicipalities}
          data-testid="municipality-ibge-code"
        />
      </Stack>
    </Box>
  )
}
